module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.tasks.black-7ebab93b97c5361ac2ed664d65db0f23.svg";